import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import router from "@/router/index.js";
import genres from "@/store/modules/genres";
import audioPlayer from "@/store/modules/audioPlayer";
import radioPlayer from "@/store/modules/radioPlayer";
import {
  extractCurrentEpisodeFromAirtimeResponse,
  extractNextEpisodeFromAirtimeResponse
} from "@/store/storeHelper";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    liveStreamInfoState: false,
    liveStreamInfoDataOne: {},
    liveStreamInfoDataTwo: {},
    liveStreamInfoDataThree: {},
    error: {},
    selectedGenres: [],
    genresState: false,
  },
  mutations: {
    setLiveStreamInfoState(state, payload) {
      state.liveStreamInfoState = payload;
    },
    setLiveStreamInfoDataOne(state, payload) {
      state.liveStreamInfoDataOne = payload;
    },
    setLiveStreamInfoDataTwo(state, payload) {
      state.liveStreamInfoDataTwo = payload;
    },
    setLiveStreamInfoDataThree(state, payload) {
      state.liveStreamInfoDataThree = payload;
    },
    setError(state, payload) {
      state.error = payload;
    },
    setGenres(state, payload) {
      state.selectedGenres = payload;
    },
    setGenresState(state, payload) {
      state.genresState = payload;
    },
  },
  actions: {
    async setLiveStreamInfoDataOne(state) {
      const liveDataOne = await axios.get('https://movementathens.airtime.pro/api/live-info-v2');
      state.commit('setLiveStreamInfoDataOne', liveDataOne.data);
    },
    async setLiveStreamInfoDataTwo(state) {
      const liveDataTwo = await axios.get('https://stegiradio3.airtime.pro/api/live-info-v2');
      state.commit('setLiveStreamInfoDataTwo', liveDataTwo.data);
    },
    async setLiveStreamInfoDataThree(state) {
      const liveDataTwo = await axios.get('https://movementathens2.airtime.pro/api/live-info-v2');
      state.commit('setLiveStreamInfoDataThree', liveDataTwo.data);
    },
    resetErrorState(state) {
      state.commit('setError', {});
    },
    async setGenresState(state) {
      const genresEnabled = await axios.get(`${router.options.api}/front/is-genres-active`);
      state.commit('setGenresState', genresEnabled.data.active);
    }
  },
  modules: {
    genres,
    audioPlayer,
    radioPlayer
  },
  getters: {
    getLiveStreamInfoState: state => state.liveStreamInfoState,
    getLiveStreamInfoDataOne: state => state.liveStreamInfoDataOne.shows,
    getLiveStreamInfoDataTwo: state => state.liveStreamInfoDataTwo.shows,
    getLiveStreamInfoDataThree: state => state.liveStreamInfoDataThree.shows,
    getLiveStreamTitle1: state => {
      return extractCurrentEpisodeFromAirtimeResponse(state.liveStreamInfoDataOne.shows, 'STEGI.RADIO #1');
    },
    getLiveStreamTitle2: state => {
      return extractCurrentEpisodeFromAirtimeResponse(state.liveStreamInfoDataTwo.shows, 'STEGI.RADIO #2');
    },
    getLiveStreamTitle3: state => {
      return extractCurrentEpisodeFromAirtimeResponse(state.liveStreamInfoDataThree.shows, 'STEGI.RADIO #3');
    },
    getLiveStreamNextTitle1: state => {
      return extractNextEpisodeFromAirtimeResponse(state.liveStreamInfoDataOne.shows, 'STEGI.RADIO #1');
    },
    getLiveStreamNextTitle2: state => {
      return extractNextEpisodeFromAirtimeResponse(state.liveStreamInfoDataTwo.shows, 'STEGI.RADIO #2');
    },
    getLiveStreamNextTitle3: state => {
      return extractNextEpisodeFromAirtimeResponse(state.liveStreamInfoDataThree.shows, 'STEGI.RADIO #3');
    },
    getError: state => state.error,
    getSelectedGenres: state => state.selectedGenres,
    getGenresState: state => state.genresState,
  }
});
